<template>
  <div v-if="contact">
    <edit :contact_id="contact.id" @reload="fetchContact" ref="edit"></edit>

    <v-card tile outlined>
      <v-card-title class="pb-0">
        {{ contact.profile.name }}
        <v-spacer></v-spacer>
        <v-btn small depressed color="primary" @click="openEdit">
          Editar información
        </v-btn>
      </v-card-title>
      <v-card-text class="mt-3">
        <v-row no-gutters>
          <v-col sm="5" cols="12">
            <v-row no-gutters>
              <v-col cols="12" class="text-body">
                {{ $t("contact.show.fields.address") }}
              </v-col>
              <v-col cols="12" class="text-subtitle-1 black--text">
                {{ contact.profile.address }}
              </v-col>
            </v-row>
          </v-col>

          <v-col sm="3" cols="12">
            <v-row no-gutters>
              <v-col cols="12" class="text-body">
                {{ $t("contact.show.fields.email") }}
              </v-col>
              <v-col cols="12" class="text-subtitle-1 black--text">
                {{ contact.profile.email }}
              </v-col>
            </v-row>
          </v-col>

          <v-col sm="4" cols="12">
            <v-row no-gutters>
              <v-col cols="12" class="text-body">
                {{ $t("contact.show.fields.phone") }}
              </v-col>
              <v-col cols="12" class="text-subtitle-1 black--text">
                {{ contact.profile.phone }}
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-divider class="mt-3" />

        <div style="width: fit-content" class="mt-3">
          <div class="mb-2 d-flex align-center justify-space-between">
            <div class="text-body">
              Asesor asignado
            </div>
          </div>

          <div
            class="text-body py-2 px-3 d-flex flex-row align-center grey lighten-4 rounded-lg"
            style="gap: 12px; width: fit-content"
          >
            <v-avatar size="70" color="white">
              <v-icon size="30" color="primary">mdi-account</v-icon>
            </v-avatar>

            <div>
              <div class="mb-2">
                <v-autocomplete
                  dense
                  flat
                  outlined
                  solo
                  hide-details
                  placeholder="Seleccione un asesor"
                  v-model="contact.advisorId"
                  :items="staff"
                  item-text="name"
                  item-value="id"
                  style="width: 220px"
                  @change="updateStaff"
                ></v-autocomplete>
              </div>
              <div v-if="contact.advisor" class="text--primary">
                <v-icon small class="mt-n1 mr-1" color="primary"
                  >mdi-phone</v-icon
                >{{ contact.advisor.number }} |
                <v-icon small class="mt-n1 mr-1" color="primary"
                  >mdi-map-marker</v-icon
                >{{ contact.advisor.city }}
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { Contact } from "@/graphql/queries/directory";
import { Staff } from "@/graphql/queries/staff";
import { AttachStaff } from "@/graphql/mutations/staff";
import Edit from "./Edit";

export default {
  data: () => ({
    staff: [],
    contact: null
  }),

  created() {
    this.fetchContact();
    this.fetchStaff();
  },

  props: {
    id: {
      required: true,
      type: Number | String
    }
  },

  methods: {
    fetchContact(policy = "cache-first") {
      this.$apollo
        .query({
          query: Contact,
          variables: {
            contactId: this.id
          },
          fetchPolicy: policy
        })
        .then(res => {
          this.contact = res.data.contact;

          this.$emit('setContact', this.contact)
        });
    },

    fetchStaff() {
      this.$apollo
        .query({
          query: Staff,
          fetchPolicy: "no-cache"
        })
        .then(res => {
          this.staff = res.data.staff;
        });
    },

    updateStaff() {
      if (this.contact && this.contact.advisorId)
        this.$apollo
          .mutate({
            mutation: AttachStaff,
            variables: {
              input: {
                id: this.contact.advisorId,
                userId: this.contact.id
              }
            }
          })
          .then(res => {
            this.fetchContact("no-cache");
          });
    },

    openEdit() {
      this.$refs.edit.dialog = true;
    }
  },

  components: { Edit }
};
</script>
